(() => {
  const root = window.Shopify?.routes?.root || '/';
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const escapeHTML = (value = '') => String(value).replace(/[&<>'"]/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
  const money = cents => new Intl.NumberFormat('en-PK', { style: 'currency', currency: 'PKR', maximumFractionDigits: 0 }).format((Number(cents) || 0) / 100).replace('PKR', 'PKR ');

  function toast(message) {
    const element = $('[data-toast]');
    if (!element) return;
    element.textContent = message;
    element.classList.add('is-visible');
    clearTimeout(window.oryToastTimer);
    window.oryToastTimer = setTimeout(() => element.classList.remove('is-visible'), 2600);
  }

  function hidePreloader() {
    const loader = $('[data-preloader]');
    if (!loader) return;
    window.setTimeout(() => {
      loader.classList.add('is-hidden');
      window.setTimeout(() => loader.remove(), 600);
    }, 620);
  }
  if (document.readyState === 'complete') hidePreloader();
  else window.addEventListener('load', hidePreloader, { once: true });
  window.setTimeout(hidePreloader, 1800);

  const overlay = $('[data-drawer-overlay]');
  function closeDrawers() {
    $$('.nav-drawer,.search-drawer,.cart-drawer').forEach(drawer => drawer.classList.remove('is-open'));
    overlay?.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    $$('[aria-expanded="true"]').forEach(button => button.setAttribute('aria-expanded', 'false'));
  }
  function openDrawer(name, trigger) {
    closeDrawers();
    const drawer = $(`[data-drawer="${name}"]`);
    if (!drawer) return;
    drawer.classList.add('is-open');
    overlay?.classList.add('is-open');
    document.body.classList.add('drawer-open');
    trigger?.setAttribute('aria-expanded', 'true');
    drawer.querySelector('button,input,a')?.focus({ preventScroll: true });
    if (name === 'cart') refreshCart();
  }
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      event.preventDefault();
      openDrawer(opener.dataset.drawerOpen, opener);
      return;
    }
    if (event.target.closest('[data-drawer-close]') || event.target.matches('[data-drawer-overlay]')) closeDrawers();
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closeDrawers(); });

  const header = $('[data-header]');
  const scrollTop = $('[data-scroll-top]');
  function onScroll() {
    header?.classList.toggle('is-scrolled', window.scrollY > 18);
    scrollTop?.classList.toggle('is-visible', window.scrollY > 560);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  scrollTop?.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));

  const revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: .08 }) : null;
  $$('.reveal').forEach(item => revealObserver ? revealObserver.observe(item) : item.classList.add('is-visible'));

  $$('[data-accordion-button]').forEach(button => button.addEventListener('click', () => {
    const item = button.closest('.accordion__item');
    const panel = $('[data-accordion-panel]', item);
    const open = item.classList.toggle('is-open');
    button.setAttribute('aria-expanded', String(open));
    panel.style.maxHeight = open ? `${panel.scrollHeight}px` : '0px';
  }));

  $$('[data-tabs]').forEach(tabs => {
    const buttons = $$('[data-tab-target]', tabs);
    const panels = $$('[data-tab-panel]', tabs);
    buttons.forEach(button => button.addEventListener('click', () => {
      buttons.forEach(btn => { btn.classList.remove('is-active'); btn.setAttribute('aria-selected', 'false'); });
      panels.forEach(panel => panel.classList.remove('is-active'));
      button.classList.add('is-active');
      button.setAttribute('aria-selected', 'true');
      $(`[data-tab-panel="${button.dataset.tabTarget}"]`, tabs)?.classList.add('is-active');
    }));
  });

  $$('[data-product-gallery]').forEach(gallery => {
    const thumbs = $$('[data-media-target]', gallery);
    const media = $$('[data-media-id]', gallery);
    thumbs.forEach(thumb => thumb.addEventListener('click', () => {
      thumbs.forEach(item => item.classList.remove('is-active'));
      media.forEach(item => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
      $(`[data-media-id="${thumb.dataset.mediaTarget}"]`, gallery)?.classList.add('is-active');
    }));
  });

  document.addEventListener('click', event => {
    const control = event.target.closest('[data-quantity-change]');
    if (!control) return;
    const wrapper = control.closest('[data-quantity]');
    const input = $('input', wrapper);
    const next = Math.max(1, Number(input.value || 1) + Number(control.dataset.quantityChange));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  $$('[data-product-root]').forEach(rootElement => {
    const form = $('form.product-form', rootElement);
    const json = $('[data-product-json]', rootElement);
    if (!form || !json) return;
    const variants = JSON.parse(json.textContent);
    const radios = $$('[data-option-radio]', form);
    const idInput = $('[name="id"]', form);
    const price = $('[data-product-price]', rootElement);
    const compare = $('[data-product-compare]', rootElement);
    const add = $('[data-product-add]', form);
    function selectVariant() {
      const selected = [];
      const names = [...new Set(radios.map(radio => radio.name))];
      names.forEach(name => selected.push($(`[name="${CSS.escape(name)}"]:checked`, form)?.value));
      const variant = variants.find(item => item.options.every((option, index) => option === selected[index]));
      if (!variant) return;
      idInput.value = variant.id;
      if (price) price.textContent = money(variant.price);
      if (compare) {
        compare.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : '';
        compare.hidden = !(variant.compare_at_price > variant.price);
      }
      add.disabled = !variant.available;
      add.querySelector('span').textContent = variant.available ? 'Add to bag' : 'Sold out';
      const stickyId = $('[data-sticky-variant]');
      if (stickyId) stickyId.value = variant.id;
    }
    radios.forEach(radio => radio.addEventListener('change', selectVariant));
  });

  async function addToCart(form) {
    const submit = $('button[type="submit"]', form);
    const original = submit?.innerHTML;
    if (submit) { submit.disabled = true; submit.classList.add('is-loading'); }
    try {
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error((await response.json()).description || 'Unable to add item');
      await refreshCart();
      openDrawer('cart');
      toast('Added to your ORYEZA bag');
    } catch (error) {
      toast(error.message || 'Please try again');
    } finally {
      if (submit) { submit.disabled = false; submit.classList.remove('is-loading'); submit.innerHTML = original; }
    }
  }
  document.addEventListener('submit', event => {
    const form = event.target.closest('form.product-card__form, form.product-form, form.sticky-atc__form');
    if (!form) return;
    if (event.submitter && (event.submitter.name === 'checkout' || event.submitter.closest('.shopify-payment-button'))) return;
    event.preventDefault();
    addToCart(form);
  });

  function lineMarkup(item) {
    return `<article class="cart-line" data-cart-key="${escapeHTML(item.key)}">
      <a href="${escapeHTML(item.url)}"><img class="cart-line__image" src="${escapeHTML(item.image || '')}" alt="${escapeHTML(item.product_title)}" width="172" height="212"></a>
      <div>
        <h3><a href="${escapeHTML(item.url)}">${escapeHTML(item.product_title)}</a></h3>
        ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-line__meta">${escapeHTML(item.variant_title)}</div>` : ''}
        <div class="cart-line__footer">
          <div class="quantity" data-cart-quantity>
            <button type="button" data-cart-change="${item.quantity - 1}" aria-label="Decrease quantity">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-cart-change="${item.quantity + 1}" aria-label="Increase quantity">+</button>
          </div>
          <strong>${money(item.final_line_price)}</strong>
        </div>
        <button class="cart-line__remove" type="button" data-cart-change="0">Remove</button>
      </div>
    </article>`;
  }

  async function refreshCart() {
    const drawer = $('[data-drawer="cart"]');
    if (!drawer) return;
    try {
      const cart = await fetch(`${root}cart.js`, { headers: { 'Accept': 'application/json' } }).then(response => response.json());
      $$('[data-cart-count]').forEach(count => count.textContent = cart.item_count);
      const titleCount = $('[data-cart-title-count]', drawer);
      if (titleCount) titleCount.textContent = cart.item_count;
      const lines = $('[data-cart-lines]', drawer);
      const empty = $('[data-cart-empty]', drawer);
      const footer = $('[data-cart-footer]', drawer);
      if (cart.item_count === 0) {
        lines.innerHTML = '';
        empty.hidden = false;
        footer.hidden = true;
      } else {
        empty.hidden = true;
        footer.hidden = false;
        lines.innerHTML = cart.items.map(lineMarkup).join('');
        $('[data-cart-subtotal]', drawer).textContent = money(cart.total_price);
      }
      const threshold = Number(document.body.dataset.freeShipping || 300000);
      const remaining = Math.max(0, threshold - cart.total_price);
      const progress = Math.min(100, (cart.total_price / threshold) * 100);
      $('[data-shipping-bar]', drawer)?.style.setProperty('width', `${progress}%`);
      const message = $('[data-shipping-message]', drawer);
      if (message) message.textContent = remaining > 0 ? `Add ${money(remaining)} more for free delivery` : 'You unlocked free delivery';
    } catch (error) {
      console.warn('ORYEZA cart refresh failed', error);
    }
  }
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-cart-change]');
    if (!button) return;
    const line = button.closest('[data-cart-key]');
    if (!line) return;
    button.disabled = true;
    try {
      await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: line.dataset.cartKey, quantity: Number(button.dataset.cartChange) }) });
      await refreshCart();
    } catch (error) { toast('Could not update bag'); }
  });

  $('[data-sort-by]')?.addEventListener('change', event => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    window.location.assign(url.toString());
  });

  const mainProductForm = $('form.product-form');
  const sticky = $('[data-sticky-atc]');
  if (mainProductForm && sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(entries => sticky.classList.toggle('is-visible', !entries[0].isIntersecting), { threshold: .1 }).observe(mainProductForm);
  }

  $$('[data-quiz]').forEach(quiz => {
    const steps = $$('[data-quiz-step]', quiz);
    const progress = $('[data-quiz-progress]', quiz);
    const answers = {};
    function show(index) {
      steps.forEach((step, stepIndex) => step.classList.toggle('is-active', stepIndex === index));
      if (progress) progress.style.width = `${((index + 1) / steps.length) * 100}%`;
    }
    $$('[data-quiz-option]', quiz).forEach(option => option.addEventListener('click', () => {
      const step = option.closest('[data-quiz-step]');
      $$('[data-quiz-option]', step).forEach(item => item.classList.remove('is-selected'));
      option.classList.add('is-selected');
      answers[step.dataset.quizStep] = option.dataset.quizOption;
      const next = Number(step.dataset.quizStep) + 1;
      window.setTimeout(() => show(Math.min(next, steps.length - 1)), 220);
    }));
    $('[data-quiz-finish]', quiz)?.addEventListener('click', () => {
      const result = $('[data-quiz-result]', quiz);
      steps.forEach(step => step.classList.remove('is-active'));
      result.hidden = false;
      result.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    show(0);
  });

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    const active = button.getAttribute('aria-pressed') === 'true';
    button.setAttribute('aria-pressed', String(!active));
    button.classList.toggle('is-active', !active);
  });

  refreshCart();
})();
